import React from 'react';
import { ScreenReaderOnly } from '@amount/frontend-components';

const AvantLogo: React.FC = () => (
  <>
    {/* eslint-disable-next-line @typescript-eslint/no-require-imports */}
    <img src={require('../../../../images/logo.svg')} alt='Avant Logo' data-test-id="header-logo" />
    <ScreenReaderOnly>Avant Logo</ScreenReaderOnly>
  </>
);

export default AvantLogo;
